// path dos banners na pasta "public"
export const bannersPath = [
  './assets/banners/Banner-001.webp',
  './assets/banners/Banner-002.webp',
  './assets/banners/Banner-003.webp',
  './assets/banners/Banner-004.webp',
  './assets/banners/Banner-005.webp',
  './assets/banners/Banner-006.webp'
]
